import { AxiosPromise } from "axios";
import request from "@/utils/request";
const URL = "/core";

export function getInTouchForm(data): AxiosPromise {
  return request({
    url: `${URL}/contact`,
    method: "post",
    data,
  });
}

export function getAllCountries(): AxiosPromise {
  return request({
    url: `${URL}/country-codes`,
    method: "get",
  });
}
